
const VendorPolicy = () => {
  return (
    <>
      <div className="policy-wrapper bg-white overflow-hidden">
        {/* Header Banner */}
        <div className="w-screen h-64 md:h-[430px] border-[3px] border-[#35A93E]">
          <img
            src="/vendor.jpeg"
            alt="Vendor Banner"
            className="w-full h-full object-contain md:object-contain"
          />
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 my-6">
          <div className="border-b border-gray-200 pb-6 mb-10">
            <h1 className="text-2xl font-bold text-gray-900">LifeOnPlus Vendor Policy Disclaimer</h1>
          </div>

          {/* Section 1: Introduction */}
          <section className="mb-12">
            <p className="text-base text-gray-700 leading-7">
              LifeOnPlus operates as a digital aggregator platform, connecting end users with a wide range of verified service providers and product vendors across healthcare, wellness, diagnostics, and lifestyle domains.
            </p>
          </section>

          {/* Section 2: Disclaimer */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Disclaimer</h2>
            <ul className="list-disc pl-6 text-gray-700 leading-7">
              <li className="mb-2">LifeOnPlus does not manufacture, own, or directly sell any of the listed products or services.</li>
              <li className="mb-2">All sales, services, returns, replacements, warranties, pricing, delivery, and post-sale support are subject to the individual vendor’s terms and conditions.</li>
              <li className="mb-2">LifeOnPlus facilitates the discovery, booking, and transactional interface only.</li>
              <li className="mb-2">The platform shall not be held responsible for any discrepancies in quality, delay, non-performance, or refund issues, which are to be resolved as per the vendor’s policy.</li>
            </ul>
          </section>

          {/* Section 3: Shopping & Service Policies */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Shopping & Service Policies</h2>
            <p className="text-base text-gray-700 leading-7">
              Each vendor/seller on the LifeOnPlus platform agrees to follow a standardized vendor onboarding policy, which includes:
            </p>
            <ul className="list-disc pl-6 text-gray-700 leading-7 mt-2">
              <li className="mb-2">Product/service listing guidelines</li>
              <li className="mb-2">Mandatory license and certification verification</li>
              <li className="mb-2">Transparent pricing and TAT (Turnaround Time)</li>
              <li className="mb-2">Clear return, refund, and cancellation policies</li>
              <li className="mb-2">Statutory tax compliance and customer support protocols</li>
            </ul>
          </section>

          {/* Section 4: Note to Users */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Note to Users</h2>
            <p className="text-base text-gray-700 leading-7">
              Before making a purchase or availing a service, users are advised to review the specific vendor policy, terms of service, and warranty (if any) listed on the product or service detail page.
            </p>
            <p className="text-base text-gray-700 leading-7 mt-3">
              For concerns related to a specific vendor or transaction, please contact:
              <br />
              <strong>Vendor Support Team</strong><br />
              Email: <a href="mailto:support@lifeonplus.com" className="text-blue-600 hover:underline">support@lifeonplus.com</a>
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default VendorPolicy;
